export default __webpack_public_path__ + "static/media/boats.c8eeca8c.jpg";